import {EnabledTruckConfiguration, TruckConfiguration} from './types'

export const getTruckTypeSettings = (
  configuration: EnabledTruckConfiguration,
  truckType?: string
) => {
  if (!truckType) {
    return configuration.defaultTruck
  }

  return (
    configuration.truckTypes.values.find((type) => type.number === truckType) ||
    configuration.defaultTruck
  )
}

export const getTruckSize = (
  truckConfiguration: TruckConfiguration['trucks'],
  truckType?: string
) => {
  if (!truckConfiguration.isEnabled) {
    return truckConfiguration.defaultTruckSize
  }

  return (
    getTruckTypeSettings(truckConfiguration, truckType)?.size ??
    truckConfiguration.defaultTruck.size
  )
}

export const getDefaultTruckSize = (truckConfiguration: TruckConfiguration['trucks']) => {
  if (!truckConfiguration.isEnabled) {
    return truckConfiguration.defaultTruckSize
  }

  return truckConfiguration.defaultTruck.size
}

export const isMultipleTruck = (quantity: number, truckSize: number) => quantity > truckSize
